import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AlertService, AuthenticationService, UserService} from '../../_services/index';

import {User} from '../../_models/index';

import {LoginHelper, Role, StringsHelper} from '../../helpers';


import {UserComponent} from '../user/index';
import {PasswordGeneratedComponent} from "../passwordGenerated/password.generated.component";
import {UserPopupComponent} from "../userPopup";
import {MatDialog, MatDialogConfig, MatDialogRef} from "@angular/material/dialog";
import {Constants} from "../../helpers/constants";

@Component({
    standalone: false,
  selector: "users-component",
  templateUrl: 'users.component.html',
  styleUrls: ['./users.component.scss'],
})

export class UsersComponent implements OnInit {
  allUsers: User[];
  users: User[];
  inactiveUsers: User[];
  surveyUsers: User[];
  awarenessUsers: User[];
  vendorUsers: User[];
  expanded = {};
  msg: string;
  public currentUser: User;

  public roleGroups = ["Users", "Advisors", "Awareness", "Survey", "Assessors", "Admins", "Workstream", "System", "Unknown"]

  dialogRef: MatDialogRef<UserPopupComponent> | null;

  cols : any[] = [
    {'field': 'lastName', 'header': 'Last Name'},
    {'field': 'firstName', 'header': 'First Name'},
    {'field': 'role', 'header': 'Role'},
    {'field': 'companyName', 'header': 'Company'},
    {'field': 'memberOf', 'header': 'Member Of'},
    {'field': 'emailAddress', 'header': 'E-mail Address'}
  ]

  inactiveCols : any[] = [...this.cols, {'field': 'lastLoginTime', 'header': 'Last Login'}]

  rowGroupMetadata = {};
  inactiveRowGroupMetadata = {};
  selectedIndex = 0;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public userService: UserService,
    public authenticationService: AuthenticationService,
    public alertService: AlertService,
    public dialog: MatDialog) {
  }

  ngOnInit() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }

    this.currentUser = this.getCurrentUser();

    this.loadUsers();
  }

  editUser(userId: number) {

    let user =
      this.allUsers.find(x => x.userId == userId);

    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '548px',
      minWidth: "300px",
      data: {
        user: user || {},
        roles: this.selectedIndex === 1 ? [Role.Survey] : this.selectedIndex === 2 ? [Role.Training] : this.selectedIndex === 3 ? [Role.Vendor] : null
      }
    };

    this.dialogRef = this.dialog.open(UserPopupComponent, config);

    this.dialogRef.afterClosed().subscribe((result: any) => {
      this.alertService.suppressRootAlert.next(false);
      this.alertService.clear();

      this.loadUsers();
    });
  }

  deleteUser(userId: number) {

    this.userService.delete(userId).subscribe(data => {
        this.loadUsers();
      },
      (error: Response) => {
        const errorMessage = 'An error occurred while deleting user.';
        this.alertService.error(errorMessage);
      });
  }

  unlockUser(userId: number) {

    this.userService.unlock(userId).subscribe(data => {
        this.loadUsers();
      },
      (error: Response) => {
        const errorMessage = 'An error occurred while unlocking user.';
        this.alertService.error(errorMessage);
      });
  }

  public loadUsers() {
    this.expanded = {0: true, 1: true, 2: true, 3: true, 4: true, 5: true, 6: true, 7: true};
    this.userService.getAll().subscribe(data => {
        this.allUsers = data;
        for (let i = 0; i < data.length; i++) {
          data[i].roleGroup = (data[i].role & (Role.User | Role.Manager | Role.PrimaryManager)) != 0 ? 0 :
            (data[i].role & (Role.AdvisorStaff | (Role.AdvisorLead | Role.PrimaryAdvisorLead | Role.PlatformSupport))) != 0 ? 1 :
              (data[i].role & (Role.Training)) != 0 ? 2 :
                (data[i].role & (Role.Survey)) != 0 ? 3 :
                    (data[i].role & (Role.Assessor)) != 0 ? 4 :
                      (data[i].role & (Role.KingAdmin | Role.Admin)) != 0 ? 5 :
                        (data[i].role & (Role.Engineer)) != 0 ? 6 : 7
          data[i].lastLoginTime = data[i].lastLoginTime ? new Date(data[i].lastLoginTime) : null;
        }
        this.users = this.allUsers.sort((a: any, b: any) => a.roleGroup - b.roleGroup);
        this.surveyUsers = this.allUsers.filter(u => u.role == Role.Survey);
        this.awarenessUsers = this.allUsers.filter(u => u.role == Role.Training);
        this.vendorUsers = this.allUsers.filter(u => u.role == Role.Vendor);
        this.filterInactiveUsers(10);
        this.users = this.allUsers.filter(u => u.role != Role.Survey && u.role != Role.Training && u.role != Role.Vendor);
        this.updateRowGroupMetaData();
      },
      error => {
        console.log(error);
        const errorMessage = 'An error occurred while loading users.';
        this.alertService.error(errorMessage);
      });
  }

  getRole(role: number): string {

    return StringsHelper.getRole(role);
  }

  public getCurrentUser(): User {

    return JSON.parse(sessionStorage.getItem('currentUser'));
  }

  public isDeletable(user: User): boolean {
    return LoginHelper.getTenantName() !== Constants.RiskSpongeMaster || user.role !== Role.KingAdmin || this.users.filter(u => u.role === Role.KingAdmin).length > 1;
  }

  setUserDisabled(userId: number, disabled: boolean) {
    this.userService.setUserDisabled(userId, disabled).subscribe(data => {
        this.loadUsers();
      },
      (error: Response) => {
        const errorMessage = 'An error occurred while disabling user.';
        this.alertService.error(errorMessage);
      });
  }

  generatePassword(userId: number) {
    this.userService.generatePassword(userId).subscribe(data => {
        let config: MatDialogConfig = {
          panelClass: 'custom-overlay-pane-class',
          width: '30%',
          data: data
          //height: '600px',
        };

        this.dialog.open(PasswordGeneratedComponent, config);
      },
      (error: Response) => {
        const errorMessage = 'An error occurred while disabling user.';
        this.alertService.error(errorMessage);
      });
  }

  updateRowGroupMetaData() {
    const data = this.users;
    const field = "roleGroup";
    this.rowGroupMetadata = {};
    if (data) {
      for (let i = 0; i < data.length; i++) {
        let rowData = data[i];
        let brand = rowData[field];
        if (i == 0) {
          this.rowGroupMetadata[brand] = {index: 0, size: 1};
        } else {
          let previousRowData = data[i - 1];
          let previousRowGroup = previousRowData[field];
          if (brand === previousRowGroup)
            this.rowGroupMetadata[brand].size++;
          else
            this.rowGroupMetadata[brand] = {index: i, size: 1};
        }
      }
      console.log('1');
      console.log(this.rowGroupMetadata);
      this.inactiveRowGroupMetadata = {};
      for (let i = 0; i < this.inactiveUsers.length; i++) {
        let rowData = this.inactiveUsers[i];
        let brand = rowData[field];
        if (i == 0) {
          this.inactiveRowGroupMetadata[brand] = {index: 0, size: 1};
        } else {
          let previousRowData = this.inactiveUsers[i - 1];
          let previousRowGroup = previousRowData[field];
          if (brand === previousRowGroup)
            this.inactiveRowGroupMetadata[brand].size++;
          else
            this.inactiveRowGroupMetadata[brand] = {index: i, size: 1};
        }
      }
      console.log('2');
      console.log(this.inactiveRowGroupMetadata);
    }
  }

  filterInactiveUsers(inactivityDays) {
    let date = new Date();
    if (inactivityDays) {
      date.setDate(date.getDate() - inactivityDays)
    }
    this.inactiveUsers = this.allUsers.filter(u => !u.lastLoginTime || u.lastLoginTime < date);
  }

  formatDateTime(date) {
    if (!date) return '';
    return new Intl.DateTimeFormat('en-US', <any>{ dateStyle: 'medium', timeStyle: 'medium' }).format(date);
  }
}
